import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { setFullscreenSnapshot } from '../../components/Snapshot/LightBox/actions';

import style from './style.module.scss';

const Snapshot = (props) => {
  const {
    setFullscreenSnapshotAction,
  } = props;
  const { snapshotId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setFullscreenSnapshotAction(snapshotId);
    navigate('/', { replace: true });
  }, [navigate, setFullscreenSnapshotAction, snapshotId]);

  return (
    <div className={style.wrapper}>
      <Spinner animation="border" variant="primary" />
    </div>
  );
};

export default connect(
  ({ snapshots: { fullscreenSnapshot: snapshot } }) => ({ snapshot }),
  { setFullscreenSnapshotAction: setFullscreenSnapshot },
)(Snapshot);
